<template>
  <Select v-model="policy" :options="policies" optionLabel="name" :placeholder="$t('menu.policy')" @change="change" />
</template>

<script>
import { ref } from 'vue'
import router from '../../router'
import { useI18n } from 'vue-i18n'

export default {
  methods: {
    change() {
      const routeData = router.resolve({
        name: 'policy',
        params: { index: this.policy.code }
      })
      window.open(routeData.href, '_blank')
      this.policy = {}
    }
  },
  components: {
  },
  setup() {
    const { t } = useI18n()

    const policy = ref({})
    const policies = ref([
        { name: `${t('menu.order')}`, code: 0 },
        { name: `${t('menu.cost')}`, code: 1 },
        { name: `${t('menu.delivery')}`, code: 2 },
        { name: `${t('menu.dispute')}`, code: 3 },
        { name: `${t('menu.terms')}`, code: 400 },
        { name: `${t('menu.privacy')}`, code: 500 },
        { name: `${t('menu.etc')}`, code: 4 },
    ])
    return {
      policy, policies
    }
  },
  data() {
    return {
    }
  },
}
</script>

<style scoped>
</style>
